import { createContext } from "react";
export const Context = createContext({});
Context.displayName = "Hangman";
